import { useTranslation } from 'react-i18next';

export function KPIDetailPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-24 px-4">
      <h2 className="text-lg font-semibold">{t('KPI.underConstruction')}</h2>
      <p className="max-w-md text-sm text-muted-foreground">
        {t('KPI.underConstructionDesc')}
      </p>
    </div>
  );
}
